import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=68665586&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&id=68665586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68665586",
  null
  
)

export default component.exports